import Vue from 'vue'

export default {
	getDashboardList () {
		return Vue.http.get('dashboard')
	}
}
